import React from 'react';
import Dictionary from './dictionary/Dictionary';
import './App.css';

function App() {
  return (
    <div className="App">
    <div className="container">
      <Dictionary />
    </div>
    <footer>
      <a href="https://github.com/Kemi-ol/react-dictionary"> <small>Coded by Kemi Oluwasanmi </small></a>
   
    </footer>
    </div>
  );
}

export default App;
